import { UuidSchema } from "@mind/contracts/browser";

export type WorkspaceSearch = {
  readonly workspace?: string;
};

export function validateWorkspaceSearch(input: unknown): WorkspaceSearch {
  if (input === null || typeof input !== "object" || Array.isArray(input)) {
    throw new TypeError("Protected route search must be an object");
  }

  const search = input as Readonly<Record<string, unknown>>;
  const unexpectedKey = Object.keys(search).find((key) => key !== "workspace");
  if (unexpectedKey !== undefined) {
    throw new TypeError(`Unexpected protected route search key: ${unexpectedKey}`);
  }

  if (search["workspace"] === undefined) return {};
  return { workspace: UuidSchema.parse(search["workspace"]) };
}

export type AnonymousSearch = Readonly<Record<string, never>>;

export function validateAnonymousSearch(input: unknown): AnonymousSearch {
  if (input === null || typeof input !== "object" || Array.isArray(input) || Object.keys(input).length > 0) {
    throw new TypeError("Anonymous routes do not accept search state");
  }
  return {};
}
